// extracted by mini-css-extract-plugin
export var modalFooter = "_rb-0";